import Vue from "vue";

export default {
  namespaced: true,
  state: {
    designerBrandView: {
      prev: 'menu',
      next: 'designer-models',
      namePage: 'brands',
      nextName: 'brand',
      data: 'brands/BRANDS',
      active: 'brands/BRAND_EDIT',
      plusName: 'Добавить марку'
    },
    designerBrandViewNew: {
      component: 'EditImg',
      prev: 'designer-brands',
      btnText: 'Добавить марку',
      componentData: {
        send: 'brands/BRAND_NEW',
        editImg: true,
        imgClass: 'card__img-only card__img--small',
        uploadText: 'Добавить логотип марки',
        inputs: [
          {
            component: 'InputText',
            name: 'name',
            label: 'Название',
            className: 'col-12',
            rules: {
              required: true
            }
          }
        ]
      }
    },
    designerBrandViewEdit: {
      component: 'EditImg',
      prev: 'designer-brands',
      btnText: 'Сохранить изменения',
      componentData: {
        data: 'brands/BRAND',
        send: 'brands/BRAND_EDIT',
        editImg: true,
        imgClass: 'card__img--small',
        uploadText: 'Выбрать новую картинку',
        inputs: [
          {
            component: 'InputText',
            name: 'name',
            label: 'Название',
            className: 'col-12',
            rules: {
              required: true
            }
          }
        ]
      }
    },
    designerBrandViewDisable: {
      component: 'EditImg',
      prev: 'designer-brands',
      btnText: 'Отключить марку',
      wrapClass: 'mt50',
      componentClass: 'img-wrap--higher flex-grow-1',
      formClass: 'edit--small',
      componentData: {
        data: 'brands/BRAND',
        send: 'brands/BRAND_EDIT',
        editImg: false,
        disable: true
      }
    },
    designerBrandViewDelete: {
      component: 'EditImg',
      prev: 'designer-brands',
      btnText: 'Удалить марку',
      wrapClass: 'mt50',
      componentClass: 'img-wrap--higher flex-grow-1',
      formClass: 'edit--small',
      componentData: {
        send: 'brands/BRAND_DELETE',
        data: 'brands/BRAND',
        editImg: false,
        // text: [
        //   {
        //     title: 'Эта марка содержит',
        //     items: [
        //       '5 моделей',
        //       '27 поколений',
        //       '8 вопросов для поколений'
        //     ]
        //   },
        //   {
        //     title: 'Все они удалятся автоматически'
        //   }
        // ]
      }
    },
    checkBrandView: {
      prev: 'menu',
      next: 'check-models',
      namePage: 'brands',
      nextName: 'brand',
      data: 'brands/BRANDS',
      designer: false,
      titleClass: 'text-no-transform'
    }
  },
  actions: {
    'BRANDS': async () => {
      return await Vue.http.get(`${process.env.VUE_APP_API_URL}brands`)
          .then(
              res => {
                return res;
              },
              err => {
                return err;
              }
          )
          .catch(err => console.error(`catch, ${err}`));
    },
    'BRAND': async (context, params) => {
      return await Vue.http.get(`${process.env.VUE_APP_API_URL}brands/${params.id}`)
          .then(
              res => {
                return res;
              },
              err => {
                return err;
              }
          )
          .catch(err => console.error(`catch, ${err}`));
    },
    'BRAND_NEW': async (context, params) => {
      params.filename = params.photo;
      delete params.photo;
      let formData = new FormData();
      for (let key in params) {
        formData.append(key, params[key]);
      }
      return await Vue.http.post(`${process.env.VUE_APP_API_URL}brands`, formData)
          .then(
              res => {
                return res;
              },
              err => {
                return err;
              }
          )
          .catch(err => console.error(`catch, ${err}`));
    },
    'BRAND_DELETE': async (context, params) => {
      return await Vue.http.delete(`${process.env.VUE_APP_API_URL}brands/${params.id}`,)
          .then(
              res => {
                return res;
              },
              err => {
                return err;
              }
          )
          .catch(err => console.error(`catch, ${err}`));
    },
    'BRAND_EDIT': async (context, params) => {
      params.idbrand = params.id;
      delete params.id;
      params.filename = params.photo;
      delete params.photo;
      let formData = new FormData();
      for (let key in params) {
        formData.append(key, params[key]);
      }
      return await Vue.http.put(`${process.env.VUE_APP_API_URL}brands`, formData)
          .then(
              res => {
                return res;
              },
              err => {
                return err;
              }
          )
          .catch(err => console.error(`catch, ${err}`));
    }
  }
}